import { lazy } from 'react'

const ForgotPassword = lazy(() => import('../../views/pages/auth/forgot-password'))
const ResetPassword = lazy(() => import('../../views/pages/auth/forgot-password/reset'))
const Login = lazy(() => import('../../views/pages/auth/login'))
const Register = lazy(() => import('../../views/pages/auth/register'))

const routes = [
	{
		path: '/forgot-password',
		element: <ForgotPassword />,
		meta: {
			layout: 'blank',
			publicRoute: true
		}
	},
	{
		path: '/verify-resetpassword/:token',
		element: <ResetPassword />,
		meta: {
			layout: 'blank',
			publicRoute: true
		}
	},
	{
		path: '/login',
		element: <Login />,
		meta: {
			layout: 'blank',
			publicRoute: true
		}
	},
	{
		path: '/register',
		element: <Register />,
		meta: {
			layout: 'blank',
			publicRoute: true
		}
	}
]

export default routes
